import './styles/index.css';
import './styles/profile.css';
import './styles/renew.css';
import './styles/renew-success.css';
import './styles/schedule.css';
import './styles/checkin.css';
import './styles/collect-point.css';
import './styles/bootstrap.css';
import './styles/antd.css';
import './styles/antd-cumtom.css';
import { Provider, connect } from 'react-redux';
import store from './redux/configure-store'
import { RouterProvider } from "react-router-dom";
import router from './Router'
import GetConfig from './components/GetConfig'

function App() {
  return (
    <Provider store={store}>
      <div className="app">
          <GetConfig/>
         <RouterProvider router={router} />
      </div>
     </Provider>
  );
}

export default App;
